<script setup lang="ts">
import { ref } from "vue";

import SearchableModel from "../searchable-model/SearchableModel.vue";
import MaintenanceRecordIndexTable from "./MaintenanceRecordIndexTable.vue";
import { Button } from "@/shadcn/components/ui/button";
import { Icon } from "@/components/ui/icon";
import MaintenanceRecordEdit from "./MaintenanceRecordEdit.vue";

// Props
const props = defineProps({
  baseFilters: {
    type: Object,
  },
  availableFilters: {
    type: Array,
    default: () => [],
  },
  withExport: {
    type: Boolean,
    default: false,
  },
  pushState: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: null,
  },
  equipmentId: {
    type: Number,
    default: null,
  },
  maintenanceTypes: {
    type: Array,
    default: () => [],
  },
  maintenanceStatuses: {
    type: Array,
    default: () => [],
  },
  healthStates: {
    type: Array,
    default: () => [],
  },
  currencies: {
    type: Array,
    default: () => [],
  },
})

// Reactive data
const searchableModelRef = ref(null)
const selectedRecord = ref(null);
const showModal = ref(false);
const isEditing = ref(false);
// Methods
const getResults = () => {
  if (searchableModelRef.value) {
    searchableModelRef.value.refresh()
  }
}

const openModal = (record, shouldEdit) => {
  selectedRecord.value = record;
  isEditing.value = shouldEdit;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedRecord.value = null;
};
const onRecordSaved = () => {
  closeModal();
  getResults();
};

</script>
<template>
  <SearchableModel
    model-name="MaintenanceRecord"
    :base-filters="props.baseFilters"
    :available-filters="availableFilters"
    with-export
    :push-state="pushState"
    ref="searchableModelRef"
    :class="props.className"
  >
    <template #header-title>
      <slot name="header-title" />
    </template>
    <template #header-actions>
      <Button as-child @click="openModal(null, true)">
          <span>
            <Icon name="CirclePlus"></Icon>
            {{ $t("Create new record") }}
          </span>
      </Button>
    </template>
    <template #default="{ models }">
      <MaintenanceRecordIndexTable v-if="models"
                                   :maintenance-records="models"
                                   @edit-record="({ record, shouldEdit }) => openModal(record, shouldEdit)"/>
    </template>
  </SearchableModel>
  <MaintenanceRecordEdit
    v-if="showModal"
    :show-modal="showModal"
    :is-editing="isEditing"
    :equipment-id="equipmentId"
    :maintenance-record="selectedRecord"
    :maintenance-types="props.maintenanceTypes"
    :maintenance-statuses="props.maintenanceStatuses"
    :health-states="props.healthStates"
    :currencies="props.currencies"
    @close="closeModal"
    @saved="onRecordSaved"
  />
</template>